import React from 'react'
import MessagingDownloadIcon from './messaging-download-icon'
import MessagingFileIcon from './messaging-file-icon'
import { sanitizeAttachmentUrl } from './messaging-utils'

const formatFileSize = fileSize => {
  const size = typeof fileSize === 'string' ? parseFloat(fileSize) : fileSize

  if (typeof size === 'undefined' || !Number.isFinite(Number(size))) {
    return null
  }

  const units = ['B', 'kB', 'MB', 'GB']
  let value = Number(size)
  let unitIndex = 0

  while (value >= 1024 && unitIndex < units.length - 1) {
    value /= 1024
    unitIndex += 1
  }

  const precision = unitIndex === 0 ? 0 : 1
  return `${value.toFixed(precision)} ${units[unitIndex]}`
}

const MessagingFileAttachment = ({ attachment }) => {
  const formattedSize = formatFileSize(attachment.file_size)
  const downloadUrl = sanitizeAttachmentUrl(attachment.asset_url)

  return (
    <div
      className="str-chat__message-attachment-file--item messaging-file-attachment"
      data-testid="attachment-file"
    >
      <MessagingFileIcon
        className="str-chat__file-icon"
        mimeType={attachment.mime_type}
      />
      <div className="str-chat__message-attachment-file--item-text">
        <div
          className="str-chat__message-attachment-file--item-name"
          data-testid="file-title"
          title={attachment.title}
        >
          {attachment.title}
        </div>
        {formattedSize && (
          <span
            className="str-chat__message-attachment-file--item-size"
            data-testid="file-size-indicator"
          >
            {formattedSize}
          </span>
        )}
      </div>
      {downloadUrl && (
        <>
          <span aria-hidden className="messaging-file-attachment__divider" />
          <a
            className="str-chat__message-attachment-file--item-download"
            download
            href={downloadUrl}
            rel="noopener noreferrer"
            target="_blank"
          >
            <MessagingDownloadIcon className="str-chat__message-attachment-download-icon" />
          </a>
        </>
      )}
    </div>
  )
}

export default MessagingFileAttachment
